import { IAddress } from './address.interface';

export interface ICustomerDetails {
  id?: string;
  firstName?: string;
  lastName?: string;
  telephoneNumber?: string;
  dateOfBirth?: Date;
  address?: IAddress;
  postcodeValidForChildTickets?: boolean;
}

export const EMPTY_CUSTOMER_DETAILS: ICustomerDetails = {
  firstName: '',
  lastName: '',
  telephoneNumber: undefined,
  dateOfBirth: undefined,
  address: {
    address1: '',
    address2: '',
    town: '',
    county: '',
    country: '',
    postCode: '',
  },
};
